import { Component, OnInit, ViewChild } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import {IOption} from "ng-select";
import * as Dropzone from "dropzone";
import {
  DropzoneComponent,
  DropzoneConfigInterface,
  DropzoneDirective,
} from "ngx-dropzone-wrapper";

import {HelperService} from "../../services/helper.service";
import {TosterMessageService} from '../../services/toster-message.service';

@Component({
  selector: 'app-add-certification-details-modal',
  templateUrl: './add-certification-details-modal.component.html',
  styleUrls: ['./add-certification-details-modal.component.scss'],
  providers: [ TosterMessageService, HelperService]
})
export class AddCertificationDetailsModalComponent implements OnInit {

  @ViewChild(DropzoneComponent) public componentRef?: DropzoneComponent;
  public certificationArr: Array<IOption> = [];
  colorTheme = 'theme-blue';
  public certification_detail: any = {
    attachment: []
  };
  bsConfig: Partial<BsDatepickerConfig>;
  files: File[] = [];
  today = new Date();


  constructor(
    private helperService: HelperService, 
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private tosterMessageService: TosterMessageService,

  ) {
    this.bsConfig = Object.assign({}, {
      containerClass: this.colorTheme,
      dateInputFormat: 'DD/MM/YYYY'
    });
  }

  ngOnInit() { }


  public closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("modalClosed");
  }

  public closeModalAfterSave() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("modalSaved");
  }

  public createCertification(event) {
    if(this.files.length == 0){
     this.closeModalAfterSave()
    }else {
      const that = this;
      let reader = 0;
      that.certification_detail.attachment = [];
      for (let i = 0; i < this.files.length; i++) {
        this.helperService.readFile(this.files[i]).then(fileContents => {
          reader = reader + 1;
          // Put this string in a request body to upload it to an API.
          let tem = this.files[i];
          let parts = tem.name.split('.');
          let data = {
            name: tem.name,
            size: tem.size,
            type: tem.type,
            extension: parts[parts.length - 1],
            file: fileContents
          };
          that.certification_detail.attachment.push(data);
          if (reader == (this.files.length)) {
           this.closeModalAfterSave()
          }
        });
      }
    }
  }

  processCountryDropdown(value){
    this.certification_detail.certification_type = value
  }

  onSelect(event) {
    if(this.files.length >= 1){
     return this.tosterMessageService.showWarning("Warning", "Cannot add multiple attachments");
    }
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }


}



// WEBPACK FOOTER //
// /app/src/app/supplier-evaluation-form/add-certification-details-modal/add-certification-details-modal.component.ts